<template>
    <BreadCrumb PageTitle="Ajouter une catégorie Produit" />
    <AddModalCategProduit/>
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AddModalCategProduit from "@/components/CategorieProduit/AddModalCategProduit.vue";

    export default defineComponent({
        name: "AddCategoriePPage",
        components: {
            BreadCrumb,
            AddModalCategProduit,
        },
    });
</script>